export const Compare = (string1: string, string2: string) => {
  let value = false;
  string1.toLocaleUpperCase() === string2.toLocaleUpperCase()
    ? (value = true)
    : (value = false);
  return value;
};
